import {Entity} from '../../core/commons/entity';
import {User} from '../../core/domain/user';
import {Topic} from './topic';
import {Reply} from './reply';
/**
 * Created by Lauta on 15/3/2017.
 */
export class Post implements Entity {
    id: number;
    title: string;
    content: string;
    publishTime: number;
    replyCount: number;
    likeCount: number;
    postOpen: boolean;
    user: User;
    topic: Topic;
    replies: Reply[];


    constructor(value: Object = {}) {
        Object.assign(this, value);
        if (this.user)
            this.user = new User(this.user);
        if (this.topic)
            this.topic = new Topic(this.topic);
        if (this.replies)
            this.replies = this.replies.map(r => new Reply(r));
    }

    public getPublishTime(): string {
        const today = new Date();
        const publishTime = new Date(this.publishTime);
        let diff = today.getTime() - publishTime.getTime();
        const diffInDays = diff / (1000 * 3600 * 24); // Diff in days
        if ( diffInDays < 1 ){
            diff = Math.ceil(diff / (1000 * 3600)); // Diff in hours
            if (diff === 1) {
                return 'hace ' + diff + ' hora';
            }
            return 'hace ' + diff + ' horas';

        }
        if ( diffInDays <= 30 ) {
            return 'hace ' + Math.ceil(diffInDays) + ' dias';
        }
        return publishTime.getDay() + '/' + publishTime.getMonth() + '/' + publishTime.getFullYear();
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/post.ts